import React from 'react';

const EmployerBranding = (props: React.PropsWithChildren<React.SVGProps<SVGSVGElement>>) => (
  <svg
    {...props}
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    role="img"
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.4453 20.9542C15.723 19.4325 14.1712 18.375 12.375 18.375H6.375C3.8895 18.375 1.875 20.3895 1.875 22.875V28.875L4.875 30.375L5.625 40.875H13.875"
      stroke="black"
      strokeWidth="2"
      strokeLinecap="square"
    />
    <path
      d="M9.375 13.875C11.8603 13.875 13.875 11.8603 13.875 9.375C13.875 6.88972 11.8603 4.875 9.375 4.875C6.88972 4.875 4.875 6.88972 4.875 9.375C4.875 11.8603 6.88972 13.875 9.375 13.875Z"
      stroke="black"
      strokeWidth="2"
      strokeLinecap="square"
    />
    <path
      d="M32.3047 20.9542C33.027 19.4325 34.5787 18.375 36.375 18.375H42.375C44.8605 18.375 46.875 20.3895 46.875 22.875V28.875L43.875 30.375L43.125 40.875H34.875"
      stroke="black"
      strokeWidth="2"
      strokeLinecap="square"
    />
    <path
      d="M39.375 13.875C41.8603 13.875 43.875 11.8603 43.875 9.375C43.875 6.88972 41.8603 4.875 39.375 4.875C36.8897 4.875 34.875 6.88972 34.875 9.375C34.875 11.8603 36.8897 13.875 39.375 13.875Z"
      stroke="black"
      strokeWidth="2"
      strokeLinecap="square"
    />
    <path
      d="M28.875 46.875H19.875L19.125 34.875L15.375 34.125V24.375C15.375 21.0615 18.0615 18.375 21.375 18.375H27.375C30.6885 18.375 33.375 21.0615 33.375 24.375V34.125L29.625 34.875L28.875 46.875Z"
      fill="#FB6121"
      stroke="#FB6121"
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
    <path
      d="M24.375 13.875C27.6887 13.875 30.375 11.1887 30.375 7.875C30.375 4.56129 27.6887 1.875 24.375 1.875C21.0613 1.875 18.375 4.56129 18.375 7.875C18.375 11.1887 21.0613 13.875 24.375 13.875Z"
      fill="#FB6121"
      stroke="#FB6121"
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
  </svg>
);

export default EmployerBranding;
